module.exports = __webpack_public_path__ + "img/pl.6767d378.png";